import { Text } from 'pixi.js';
import { DEFAULT_TEXT_FRAME_OPTIONS } from '../constant';
import { TextFrameOptions } from '../interface';
import Frame from './Frame';

class TextFrame extends Frame {
  public textContainer: Text;
  public options: TextFrameOptions;

  constructor(options?: Partial<TextFrameOptions>) {
    super({ ...DEFAULT_TEXT_FRAME_OPTIONS, ...(options || {}) });

    this.options = { ...DEFAULT_TEXT_FRAME_OPTIONS, ...(options || {}) };
    this.textContainer = new Text('', options);

    this.addChild(this.textContainer);
    this.setOptions(this.options);
  }

  public setText(text: string, autofit = true): void {
    this.textContainer.text = text;

    if (autofit) {
      this.options.width = this.textContainer.width;
      this.options.height = this.textContainer.height;
      this.build();
    } else if (this.textContainer.width > this.options.width) {
      while (
        this.textContainer.text.length !== 0 &&
        this.textContainer.width > this.options.width - Number(this.options.fontSize)
      ) {
        this.textContainer.text = this.textContainer.text.substring(0, this.textContainer.text.length - 1);
      }
      this.textContainer.text += '...';
    }
  }

  public build(): void {
    super.build();
    if (this.textContainer) {
      this.textContainer.style = this.options;
    }
  }
}

export default TextFrame;
